<template>
  <div>
    <mu-card-header
      titleClass="largeTitle boldTitle"
      :title="title"
      :subTitle="subTitle"
    ></mu-card-header>
    <mu-card-text class="form-group">
      <div class="field">
        <mu-text-field
          type="password"
          v-validate
          :data-vv-rules="'required'"
          data-vv-name="old_password"
          data-vv-value-path="inputValue"
          :data-vv-as="$t('message.securityPreferencesOldPassword')"
          :errorText="errors.first('old_password')"
          :label="$t('message.securityPreferencesOldPassword')"
          :hintText="$t('message.placeholderText')"
          fullWidth
          v-model="model.old_password">
        </mu-text-field>
      </div>
      <div class="field">
        <mu-text-field
          :type="model.visible ? 'text':'password'"
          v-validate
          :data-vv-rules="'required|min: 10|strong_password_regex'"
          data-vv-name="new_password"
          data-vv-value-path="inputValue"
          :data-vv-as="$t('message.securityPreferencesDesiredPassword')"
          :errorText="errors.first('new_password')"
          :label="$t('message.securityPreferencesDesiredPassword')"
          v-model="model.new_password"
          :hintText="$t('message.placeholderText')"
          fullWidth>
        </mu-text-field>
        <mu-icon-button
          class="right-icon"
          @click.native="model.visible = !model.visible"
          :icon="!model.visible ? 'visibility': 'visibility_off'"
        ></mu-icon-button>
      </div>
      <password-strength-validation :password="model.new_password"/>
      <mu-raised-button
        class="large"
        @click.native="submitForm()"
        :disabled="isSaving"
        :label="isSaving ? $t('message.updatingText') + '...' : $t('message.updateText')"
        fullWidth
        secondary>
      </mu-raised-button>
      <mu-divider />
      <email-update></email-update>
    </mu-card-text>
  </div>
</template>
<script>
  import AccountApi from '../../api/Account'
  import EmailUpdate from "../../components/EmailUpdate/EmailUpdate";
  import PasswordStrengthValidation from "../../components/PasswordStrengthValidation/PasswordStrengthValidation";

  export default {
    components: {
      EmailUpdate,
      PasswordStrengthValidation
    },
    name: 'settings-security',
    data() {
      return {
        title: this.$t('message.securityPreferencesTitle'),
        subTitle: this.$t('message.securityPreferencesSubTitle'),
        isSaving: false,
        isError: false,
        model: {
          visible: false
        },
        message: ""
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/settings/security')
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function () {
            self.isSaving = true;
            AccountApi.changePassword(self.model.old_password, self.model.new_password)
              .then(function (response) {
                self.isSaving = false;
                self.isError = false;
                self.message = "You've updated your password";
                self.$toastr.success(self.message);
              })
              .catch(function (error) {
                self.isSaving = false;
                self.isError = true;
                self.message = error.response.data.message;
                self.$toastr.success(self.message);
              })
          })
      }
    }
  }
</script>
<style>
  #updateEmail {
    margin: 8px 0 0;
  }
  .field {
    position: relative;
  }
  .field .right-icon {
    position: absolute;
    top: 13px;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// Security.vue?9aa674fe